// constants/pricing.ts

export const PRICING_HERO = {
    title: 'Transparent pricing',
    subtitle: 'Start testing for free, launch quickly, then scale to hundreds of integrations.',
    buttons: [
        { title: 'Calculate your plan', link: '#calculator' },
        { title: 'Speak to an expert', link: '/contact', icon: 'ic:round-keyboard-arrow-right' },
    ],
} as const;

// utils/pricing.ts

export const formatNumber = (amount?: number | string, digits = 0): string => {
    const options = {
        maximumFractionDigits: digits,
        minimumFractionDigits: digits,
    };
    return Number(amount || 0).toLocaleString('en', options);
};

export const formatMoney = (amount?: number | string, currency = '$', digits = 0, plus = '+'): string => {
    const formattedAmount = formatNumber(amount, digits);
    return `${currency}${formattedAmount}${Number(amount) > 0 ? plus : ''}`;
};

export const calculatePlanPrice = (plan: any, connections: number, requestsPerDay: number) => {
    const monthlyRequests = requestsPerDay * 31 * connections;

    let price = plan.min_price || 0;

    if (plan.max_requests && plan.price_per_mille_requests && monthlyRequests > plan.max_requests) {
        price += ((monthlyRequests - plan.max_requests) / 1000) * plan.price_per_mille_requests;
    }

    return price;
};

export const findSuggestedPlan = (plans: any[], connections: number, requestsPerDay: number) => {
    const monthlyRequests = requestsPerDay * 31 * connections;

    return plans.reduce(
        (suggested: any, plan) => {
            // Skip free plans if limits exceeded
            if (!plan.min_price) {
                if (plan.max_connections && connections > plan.max_connections) return suggested;
                if (plan.max_requests && monthlyRequests > plan.max_requests) return suggested;
            }

            const cost = calculatePlanPrice(plan, connections, requestsPerDay);

            if (!suggested.cost || cost < suggested.cost) {
                return { ...plan, cost };
            }

            return suggested;
        },
        { cost: 0 }
    );
};
